import React from 'react';
import BaseModal from '../../modal/BaseModal';
import BlueBookButton from '../../bluebook-button/BlueBookButton';

const AnnotationsTeacherModal = ({ onClose }) => (
  <BaseModal
    title="Highlights & Notes for Students"
    size="big"
    onClose={onClose}
    bottomContent={
      <BlueBookButton
        isWarning
        accessibility={{
          'data-test-id': 'button-primary',
          'aria-label': 'Close',
        }}
        className="mb-1 w-fit mx-auto !font-bold !py-[7px] !px-[23px] !h-auto !leading-[1.71em]"
        onClick={onClose}
      >
        Close
      </BlueBookButton>
    }
  >
    <div>
      <img
        className="max-w-full"
        src={require('./annotations-teacher-experience.png')}
      />
    </div>
  </BaseModal>
);

export default AnnotationsTeacherModal;
